import {PipeTransform, Pipe} from '@angular/core';
import {isStringMap, StringWrapper, isPresent, RegExpWrapper} from '../facade/lang';
import {InvalidPipeArgumentException} from './invalid_pipe_argument_exception';

var interpolationExp: RegExp = RegExpWrapper.create('#');
export class I18nPluralPipe implements PipeTransform {
  transform(value: number, pluralMap: {[count: string]: string}): string {
    var key: string;
    var valueStr: string;

    if (!isStringMap(pluralMap)) {
      throw new InvalidPipeArgumentException(I18nPluralPipe, pluralMap);
    }

    key = value === 0 || value === 1 ? `=${value}` : 'other';
    valueStr = isPresent(value) ? value.toString() : '';

    return StringWrapper.replaceAll(pluralMap[key], interpolationExp, valueStr);
  }
static decorators: DecoratorInvocation[] = [
{ type: Pipe, args: [{name: 'i18nPlural', pure: true}, ] },
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
